<template>
  <div class="min-h-screen bg-login flex items-center justify-center px-4">
    <div class="max-w-sm w-full">
      <!-- Logo设计 -->
      <div class="text-center mb-8">
        <div class="inline-flex items-center justify-center">
          <svg class="w-10 h-10 mr-2" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#2563EB" fill-opacity="0.1"/>
            <path d="M15.5 15C17.433 15 19 13.433 19 11.5C19 9.567 17.433 8 15.5 8C13.567 8 12 9.567 12 11.5C12 13.433 13.567 15 15.5 15Z" fill="#2563EB"/>
            <path d="M24.5 15C26.433 15 28 13.433 28 11.5C28 9.567 26.433 8 24.5 8C22.567 8 21 9.567 21 11.5C21 13.433 22.567 15 24.5 15Z" fill="#2563EB"/>
            <path d="M30 21C31.933 21 33.5 19.433 33.5 17.5C33.5 15.567 31.933 14 30 14C28.067 14 26.5 15.567 26.5 17.5C26.5 19.433 28.067 21 30 21Z" fill="#2563EB"/>
            <path d="M10 21C11.933 21 13.5 19.433 13.5 17.5C13.5 15.567 11.933 14 10 14C8.067 14 6.5 15.567 6.5 17.5C6.5 19.433 8.067 21 10 21Z" fill="#2563EB"/>
            <path d="M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z" fill="#2563EB"/>
          </svg>
          <h1 class="text-2xl font-bold logo-text tracking-tight">AirPets</h1>
        </div>
        <p class="mt-3 text-sm text-gray-600">智能宠物监测平台</p>
      </div>

      <!-- 注册表单 -->
      <div class="bg-white rounded-xl shadow-lg p-8">
        <form @submit.prevent="handleRegister">
          <!-- 手机号输入 -->
          <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 mb-1">手机号</label>
            <div class="relative">
              <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <i class="fas fa-mobile-alt"></i>
              </span>
              <input 
                v-model="phone"
                type="tel" 
                class="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors" 
                placeholder="请输入手机号"
                pattern="[0-9]{11}"
                required
              >
            </div>
            <p class="mt-1 text-xs text-red-500" v-if="errors.phone">{{ errors.phone }}</p>
          </div>

          <!-- 密码输入 -->
          <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 mb-1">设置密码</label>
            <div class="relative">
              <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <i class="fas fa-lock"></i>
              </span>
              <input 
                v-model="password"
                type="password" 
                class="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors" 
                placeholder="请设置6-20位密码"
                minlength="6"
                maxlength="20"
                required
              >
            </div>
            <p class="mt-1 text-xs text-red-500" v-if="errors.password">{{ errors.password }}</p>
          </div>

          <!-- 确认密码 -->
          <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 mb-1">确认密码</label>
            <div class="relative">
              <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <i class="fas fa-lock"></i>
              </span>
              <input 
                v-model="confirmPassword"
                type="password" 
                class="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors" 
                placeholder="请再次输入密码"
                minlength="6"
                maxlength="20"
                required
              >
            </div>
            <p class="mt-1 text-xs text-red-500" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</p>
          </div>

          <!-- 用户协议 -->
          <div class="flex items-center mb-6" style="text-align: left;">
            <input 
              v-model="agreement"
              type="checkbox" 
              id="agreementCheckbox"
              class="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500" 
              required
            >
            <span class="ml-2 text-sm text-gray-600">
              我已阅读并同意
              <a href="#" class="text-blue-600 hover:text-blue-700" @click.prevent="showUserAgreement">《用户协议》</a>
              和
              <a href="#" class="text-blue-600 hover:text-blue-700" @click.prevent="showPrivacyPolicy">《隐私政策》</a>
            </span>
          </div>

          <!-- 注册按钮 -->
          <button 
            type="submit" 
            class="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-2.5 rounded-lg text-sm font-medium transition-colors"
            :class="canSubmit ? 'hover:from-blue-700 hover:to-blue-800' : 'opacity-50 cursor-not-allowed'"
            :disabled="!canSubmit"
          >
            <i v-if="loading" class="fas fa-spinner fa-spin mr-2"></i>
            {{ loading ? '注册中...' : '注册' }}
          </button>

          <!-- 登录链接 -->
          <p class="mt-4 text-center text-sm text-gray-600">
            已有账号？
            <router-link to="/login" class="text-blue-600 hover:text-blue-700 font-medium">立即登录</router-link>
          </p>
        </form>
      </div>
    </div>

    <!-- 用户协议弹窗 -->
    <van-popup
      v-model="showUserAgreementModal"
      round
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div class="p-6">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">用户协议</h3>
        <div class="text-sm text-gray-600 space-y-4">
          <p>欢迎使用AirPets智能宠物监测平台！</p>
          <p>本协议是您与AirPets平台之间关于使用本平台服务所订立的协议。在您注册成为AirPets用户前，请您仔细阅读本协议的全部内容。如您不同意本协议的任何内容，请勿注册或使用本平台服务。</p>
          <p>1. 服务内容</p>
          <p>AirPets平台为用户提供宠物健康监测、定位追踪、行为分析等服务。</p>
          <p>2. 用户责任</p>
          <p>用户应妥善保管账号密码，对账号下的所有行为负责。</p>
          <p>3. 隐私保护</p>
          <p>我们重视用户隐私保护，详见《隐私政策》。</p>
        </div>
        <button 
          @click="showUserAgreementModal = false"
          class="mt-6 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          我知道了
        </button>
      </div>
    </van-popup>

    <!-- 隐私政策弹窗 -->
    <van-popup
      v-model="showPrivacyPolicyModal"
      round
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div class="p-6">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">隐私政策</h3>
        <div class="text-sm text-gray-600 space-y-4">
          <p>AirPets隐私政策</p>
          <p>我们非常重视您的隐私保护，本政策将说明我们如何收集、使用和保护您的个人信息。</p>
          <p>1. 信息收集</p>
          <p>我们会收集您的注册信息、设备信息、位置信息等，用于提供服务和改善用户体验。</p>
          <p>2. 信息使用</p>
          <p>我们会使用您的信息提供、维护和改进我们的服务，并开发新的服务。</p>
          <p>3. 信息保护</p>
          <p>我们采取严格的安全措施保护您的个人信息不被未授权访问、使用或泄露。</p>
        </div>
        <button 
          @click="showPrivacyPolicyModal = false"
          class="mt-6 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          我知道了
        </button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Register',
  data() {
    return {
      phone: '',
      password: '',
      confirmPassword: '',
      agreement: false,
      loading: false,
      showUserAgreementModal: false,
      showPrivacyPolicyModal: false,
      errors: {
        phone: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    canSubmit() {
      return this.phone && 
             this.password && 
             this.confirmPassword && 
             this.agreement &&
             !this.errors.phone &&
             !this.errors.password &&
             !this.errors.confirmPassword;
    }
  },
  methods: {
    ...mapActions(['register']),
    validatePhone() {
      const isValid = /^1[3-9]\d{9}$/.test(this.phone);
      this.errors.phone = isValid ? '' : '请输入正确的手机号';
      return isValid;
    },
    validatePassword() {
      const isValid = this.password.length >= 6 && this.password.length <= 20;
      this.errors.password = isValid ? '' : '密码长度需在6-20位之间';
      return isValid;
    },
    validateConfirmPassword() {
      const isValid = this.password === this.confirmPassword;
      this.errors.confirmPassword = isValid ? '' : '两次输入的密码不一致';
      return isValid;
    },
    validateForm() {
      const isPhoneValid = this.validatePhone();
      const isPasswordValid = this.validatePassword();
      const isConfirmPasswordValid = this.validateConfirmPassword();
      
      return isPhoneValid && isPasswordValid && isConfirmPasswordValid;
    },
    showUserAgreement() {
      this.showUserAgreementModal = true;
    },
    showPrivacyPolicy() {
      this.showPrivacyPolicyModal = true;
    },
    async handleRegister() {
      if (!this.validateForm()) return;
      
      this.loading = true;
      
      try {
        // 模拟注册过程
        console.log('注册信息', {
          phone: this.phone,
          password: this.password
        });
        
        setTimeout(() => {
          this.$toast.success('注册成功');
          this.$router.push('/login');
          this.loading = false;
        }, 1500);
      } catch (error) {
        this.$toast.fail('注册失败，请稍后重试');
        this.loading = false;
      }
    }
  },
  watch: {
    phone() {
      if (this.phone) this.validatePhone();
    },
    password() {
      if (this.password) this.validatePassword();
    },
    confirmPassword() {
      if (this.confirmPassword) this.validateConfirmPassword();
    }
  }
}
</script>

<style>
/* @import './assets/css/allMain.css'; */

.bg-login {
  background: linear-gradient(135deg, #EBF4FF 0%, #F0F9FF 100%);
}
.logo-text {
  background: linear-gradient(135deg, #2563EB 0%, #1E40AF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.mb-1 {
  text-align: left;
}
</style> 